// @flow

import * as React from 'react';
import ReactAI from 'react-appinsights';
import DropDownInput from "./DropDownInput";
import OptionManager from "../common/OptionManager";
import DependencyManager from "../common/DependencyManager";

import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import CalculationSectionHeader from "./CalculationSectionHeader";

type Props = {
    optionManager: OptionManager,
    dependencyManager: DependencyManager,

    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,

    typeOfLandscapeAfter: number,
    coatingAfter: number,
    asphaltTypeAfter: number,
    streetTypeAfter: number,

    typeOfLandscapeAfterMeta: ComponentMeta,
    coatingAfterMeta: ComponentMeta,
    asphaltTypeAfterMeta: ComponentMeta,
    streetTypeAfterMeta: ComponentMeta,

    phaseNr: number,

};

class CalculationBasicInfoAfterInput extends React.Component<Props> {

    render() {

        const optionManager = this.props.optionManager;
        const dependencyManager = this.props.dependencyManager;

        const onChange = this.props.onChange;
        const onBlur = this.props.onBlur;
        const onUnmount = this.props.onUnmount;

        const typeOfLandscapeAfter = this.props.typeOfLandscapeAfter;
        const coatingAfter = this.props.coatingAfter;
        const asphaltTypeAfter = this.props.asphaltTypeAfter;
        const streetTypeAfter = this.props.streetTypeAfter;

        return (

            <div className="calculation-basic-info-after input-section">

                <CalculationSectionHeader text="Platsen efter" extraClass="page-break" id={ `place-after-${this.props.phaseNr}` } />

                <div className="input-section-content">
                    <div className="row">
    
                        <DropDownInput htmlName="typeOfLandscapeAfter"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Typ av landskap"
                                       phaseNr={this.props.phaseNr}
                                       extraClassFormGroup="col-sm-6"
                                       value={typeOfLandscapeAfter}
                                       meta={this.props.typeOfLandscapeAfterMeta}
                                       includeEmptyOption={false}
                                       values={optionManager.availableSelections.typeOfLandscape} />
    
    
                        <DropDownInput htmlName="coatingAfter"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Beläggning"
                                       phaseNr={this.props.phaseNr}
                                       extraClassFormGroup="col-sm-6"
                                       value={coatingAfter}
                                       meta={this.props.coatingAfterMeta}
                                       includeEmptyOption={false}
                                       values={dependencyManager.getCoatings(typeOfLandscapeAfter)} />
                    </div>
                    
                    {coatingAfter === optionManager.ids.COATING_ASPHALT &&
                    <div className="row">
    
                        <DropDownInput htmlName="asphaltTypeAfter"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Asfaltstyp"
                                       phaseNr={this.props.phaseNr}
                                       extraClassFormGroup="col-sm-6"
                                       value={asphaltTypeAfter}
                                       meta={this.props.asphaltTypeAfterMeta}
                                       includeEmptyOption={false}
                                       values={optionManager.availableSelections.asphaltType} />
    
                        <DropDownInput htmlName="streetTypeAfter"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Gatutyp"
                                       phaseNr={this.props.phaseNr}
                                       extraClassFormGroup="col-sm-6"
                                       value={streetTypeAfter}
                                       meta={this.props.streetTypeAfterMeta}
                                       includeEmptyOption={false}
                                       values={optionManager.availableSelections.streetType} />
                    </div>
                    }
                </div>
            </div>
        );

    }

}

export default ReactAI.withTracking(CalculationBasicInfoAfterInput);



// WEBPACK FOOTER //
// ./src/components/CalculationBasicInfoAfterInput.js